import React, { Component } from "react";
import { Table, Card, Row, Button, Image, Col } from "react-bootstrap";
// import AddPaymentMode from "./AddPaymentMode";
import AddBrand from "./AddBrand";
import EditBrand from "./EditBrand";
import DeleteBrand from "./DeleteBrand";
import ViewBrand from "./ViewBrand";
import ItemBrandActive from "./BrandActive";
import ReactPaginate from "react-paginate";
var dateFormat = require("dateformat");
class Brand extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showAddModel: false,
      showEditModel: false,
      showDelModel: false,
      BrandViewShow: false,
      showStatusChangeModalView: false,
      page: 0,
      perPage: 10,
    };
  }
  componentDidMount() {
    this.props.fetchBrands();
  }

  handleAddBrand = () => {
    this.setState({
      showAddModel: true,
    });
  };
  closeAddModel = () => {
    this.setState({
      showAddModel: false,
    });
  };

  handleEditBrand = (item) => {
    this.setState({
      showEditModel: true,
      ItemList: item,
    });
  };

  closeEditModel = () => {
    this.setState({ showEditModel: false });
  };

  handleDelBrand = (item) => {
    this.setState({
      showDelModel: true,
      DeleteItem: item,
    });
  };
  closeDelModel = () => {
    this.setState({
      showDelModel: false,
    });
  };

  handleBrandView = (item) => {
    this.setState({
      BrandViewShow: true,
      brandViewDtls: item,
    });
  };

  handleClosebrand = () => {
    this.setState({ BrandViewShow: false });
  };

  resetPage = () => {
    this.setState({ page: 0 });
  };

  handlePageClick = (e) => {
    const selectedPage = e.selected;
    this.props.brandSlectedPage(selectedPage + 1);
    this.setState({ page: selectedPage });
  };
  handlePatientsorderActiveView = (item) => {
    this.setState({
      showStatusChangeModalView: true,
      ItemMasterActiveActvDtls: item,
    });
  };
  handleCloseActive = () => {
    this.setState({ showStatusChangeModalView: false });
  };
  render() {
    let p = this.state.page + 1;
    const count = this.props.BrandCount && this.props.BrandCount;
    let brandPageCount = Math.ceil(count / this.state.perPage);
    return (
      <div>
        <Card>
          <Card.Header>
            <Row className="align-items-center w-100 justify-content-between tableHeaderRow">
              <Col xs={12} sm={6} md={6} lg={6} style={{ margin: "auto" }}>
                <h3>Brands</h3>
              </Col>
              <Col xs={12} sm={6} md={6} lg={6}>
                <div className="countryRecrd">
                  <i className="cui-note icons cmnRecordIcon"></i>
                  <span className="cmnPageCount">{count ? count : 0}</span>
                  <span className="cmnResutText">Results</span>
                </div>
              </Col>
            </Row>
          </Card.Header>
          <Card.Body>
            <div>
              <Button
                style={{ marginBottom: "15px" }}
                onClick={() => this.handleAddBrand()}
              >
                <i className="fa fa-plus fa-md"></i>
                <span style={{ marginLeft: "5px", fontWeight: "bold" }}>
                  ADD
                </span>
              </Button>
              <AddBrand
                showAddModel={this.state.showAddModel}
                closeAddModel={this.closeAddModel}
                AddBrand={this.props.AddBrand}
                resetPage={this.resetPage}
              />
            </div>
            <div>
              <Table responsive className="cmnMainTable" bordered striped>
                <thead>
                  <tr className="cmnMainTableHd">
                    <th>SL NO</th>
                    <th>Name</th>
                    <th>Description</th>
                    <th>Status</th>
                    <th>Created Date</th>
                    <th>Action</th>
                  </tr>
                </thead>
                <tbody>
                  {this.props.BrandList &&
                    this.props.BrandList.map((item, i) => (
                      <tr key={i}>
                        <td>{10 * (p - 1) + i + 1}</td>
                        <td className="cmn_Cap">
                          {item !== null && item.name}
                        </td>
                        <td className="cmn_Cap commonDesc">
                          {item !== null && item.disc}
                        </td>
                        <td>
                          {item !== null && item.disabled
                            ? "DISABLED"
                            : "ACTIVE"}
                        </td>
                        <td className="cmn_Cap">
                          {item.createdAt !== null &&
                            dateFormat(item.createdAt, "mediumDate")}
                        </td>
                        <td className="cmnViewIcon">
                          <div
                            style={{
                              display: "flex",
                              justifyContent: "center",
                            }}
                          >
                            <i
                              className="fa fa-eye fa-lg "
                              onClick={() =>
                                this.handleBrandView({
                                  item: item,
                                })
                              }
                            ></i>
                            <ViewBrand
                              show={this.state.BrandViewShow}
                              handleClose={this.handleClosebrand}
                              brandViewDtls={this.state.brandViewDtls}
                              resetPage={this.resetPage}
                            />

                            <i
                              className="fa fa-edit fa-lg "
                              style={{
                                paddingLeft: 10,
                              }}
                              onClick={() => this.handleEditBrand(item)}
                            ></i>
                            <EditBrand
                              showEditModel={this.state.showEditModel}
                              closeEditModel={this.closeEditModel}
                              ItemList={this.state.ItemList}
                              EditBrand={this.props.EditBrand}
                              resetPage={this.resetPage}
                            />
                            {/* <i
                              className="fa fa-trash fa-lg"
                              style={{
                                paddingLeft: 10,
                              }}
                              onClick={() => this.handleDelBrand(item)}
                            ></i>
                            <DeleteBrand
                              showDelModel={this.state.showDelModel}
                              closeDelModel={this.closeDelModel}
                              DeleteItem={this.state.DeleteItem}
                              DeleteBrand={this.props.DeleteBrand}
                              resetPage={this.resetPage}
                            /> */}
                            <i
                              className="fa fa-ban fa-lg"
                              style={{ paddingLeft: 10 }}
                              onClick={() =>
                                this.handlePatientsorderActiveView({
                                  item: item,
                                })
                              }
                            ></i>
                            <ItemBrandActive
                              show={this.state.showStatusChangeModalView}
                              handleClose={this.handleCloseActive}
                              ItemBrandInActive={this.props.ItemBrandInActive}
                              ItemMasterActiveActvDtls={
                                this.state.ItemMasterActiveActvDtls
                              }
                              // ItemMasterActiveActvDtls={
                              //   this.state.ItemMasterActiveActvDtls
                              // }
                              // ItemMasterInActive={
                              //   this.props.ItemMasterInActive
                              // }
                              resetPage={this.resetPage}
                            />
                          </div>
                        </td>
                      </tr>
                    ))}
                </tbody>
              </Table>
              {(this.props.BrandList === undefined ||
                (this.props.BrandList &&
                  this.props.BrandList.length === 0)) && (
                <div>
                  <div className="noDataImgDiv">
                    <Image
                      className="noDataImg"
                      src={require("../../../assets/img/nodata4.png")}
                    />
                  </div>
                  <div className="noDataTextDiv">No Brands Found</div>
                </div>
              )}
            </div>
          </Card.Body>
          {brandPageCount > 1 ? (
            <div className="paginationDiv">
              <ReactPaginate
                forcePage={this.state.page}
                previousLabel={"Prev"}
                nextLabel={"Next"}
                breakLabel={"..."}
                breakClassName={"break-me"}
                pageCount={brandPageCount}
                marginPagesDisplayed={2}
                pageRangeDisplayed={5}
                onPageChange={this.handlePageClick}
                containerClassName={"pagination flex-wrap"}
                subContainerClassName={"pages pagination"}
                activeClassName={"active"}
              />
            </div>
          ) : null}
        </Card>
      </div>
    );
  }
}

export default Brand;
